<template>
  <DBox :id="'cmp-catalog-projects-sidewindow-licencing'" :addButton="false">
    <NTable
      class="dbox1"
      id="catalog-projects-sidewindow-licencing-list"
      :config="tableConfig"
      :headers="headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('licence_name')">
            <span
              class="txtov ut-link ut-text-accent5"
              :title="item['licence_name']"
            >
              {{ item["licence_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('licence_type')">
            <span class="txtov" :title="item['licence_type']">
              {{ item["licence_type"] }}
            </span>
          </td>
          <td v-bind="tdcon('licence_account_name')">
            <span class="txtov" :title="item['licence_account_name']">
              {{ item["licence_account_name"] }}
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedProjectDetails"],
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        rowHeight: 32,
        fullHeight: true
      });
    },
    list: function() {
      return this.selectedProjectDetails.project_licences || [];
    },
    headers: function() {
      return [
        createTableHeader("licence_name"),
        createTableHeader("licence_type"),
        createTableHeader("licence_account_name", { text: "Licensee" })
      ];
    }
  }
};
</script>
